module.exports = __webpack_public_path__ + "static/media/idInformation.f3297082.png";